import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { Model } from '@/modules/backend/Entities/Model';
import homeSmartApi from '@/plugins/HomeSmartApi';
import { CreateModelData } from '@/modules/backend/Dto/CreateModelData';

interface State {
  Models: Model[];
}

export const stateStore: State = {
  Models: []
};

export const getters: GetterTree<State, unknown> = {
  Models: (state) => state.Models
};

export const mutations: MutationTree<State> = {
  Models: (state, payload: Model[]) => (state.Models = payload),

  CreateModel: (state, payload: Model) => {
    state.Models = state.Models.concat(payload);
  },

  RemoveById: (state, modelId: number) => {
    state.Models = state.Models.filter((model: Model): boolean => (model.getId() !== modelId));
  }
};

export const actions: ActionTree<State, unknown> = {
  Fetch: async ({ commit }) => {
    const items = await homeSmartApi.Models.GetAll();
    commit('Models', items);
  },

  Create: async ({ commit }, payload: CreateModelData) => {
    const items = await homeSmartApi.Models.Create(payload);
    commit('CreateModel', items);
  },

  Remove: async ({ commit }, modelId: number) => {
    await homeSmartApi.Models.Remove(modelId);
    commit('RemoveById', modelId);
  }
};

export const models = {
  namespaced: true,
  state: stateStore,
  actions,
  getters,
  mutations
};
